import { FC, useState, useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import '../../pages/sign-up.less';

interface SignupFormProps {
  onEmailSubmit: (email: string) => void;
}

const SignupForm: FC<SignupFormProps> = ({ onEmailSubmit }) => {
  const [form] = Form.useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  // Watch for changes in the form fields
  const emailValue = Form.useWatch('email', form);

  // Update button state when email changes
  // These checks seem duplicative of the form validation rules
  // TODO Consolidate if possible
  useEffect(() => {
    if (!emailValue) {
      setIsButtonDisabled(true);
      return;
    }

    // Use a proper email regex for validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailValue)) {
      setIsButtonDisabled(true);
      return;
    }

    // Check domain
    // Temp disabe this
    /*
    const emailDomain = emailValue.split('@')[1];
    if (BLOCKED_DOMAINS.includes(emailDomain)) {
      setIsButtonDisabled(true);
      return;
    }
    */

    // If we get here, email seems valid - enable button
    setIsButtonDisabled(false);

    // When email becomes valid after previously being invalid,
    // clear the validation errors without showing new messages
    const fieldsError = form.getFieldsError();
    const hasEmailError = fieldsError.some(
      (field) => field.name[0] === 'email' && field.errors.length > 0
    );

    if (hasEmailError) {
      // Reset the specific field's errors without triggering validation
      form.setFields([
        {
          name: 'email',
          errors: [],
        },
      ]);
    }
  }, [emailValue, form]);

  /*
  // Temp disable professional email check
  const validateEmailDomain = (rule: RuleObject, value: string) => {
    if (!value) {
      // Skip this validator if there is no value in the email field - the required rule will handle this
      return Promise.resolve();
    }

    const emailDomain = value.split('@')[1];
    if (emailDomain && BLOCKED_DOMAINS.includes(emailDomain)) {
      return Promise.reject(PERSONAL_EMAIL_SIGNUP_ERROR);
    }
    return Promise.resolve();
  };
  */

  const handleSubmit = (values: { email: string }) => {
    onEmailSubmit(values.email);
  };

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
      className="signupForm"
    >
      <Form.Item
        name="email"
        label="Email address"
        className="previewInput"
        validateTrigger={['onBlur']}
        validateFirst={true}
        rules={[
          {
            required: true,
            message: 'Please enter your email address',
          },
          {
            type: 'email',
            message: 'Please enter a valid email address',
          },
          /*
          // Temp disable professional email check
          {
            validator: validateEmailDomain,
          },
          */
        ]}
      >
        <Input placeholder="email@example.com" autoComplete="email" />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="previewButton"
          disabled={isButtonDisabled}
        >
          Continue
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SignupForm;
